import FormsLoader from "@/components/forms/FormsLoader";
import FormsAI from "@/components/forms/FormsAI";
import DialogManager from "@/utils/DialogManager";
import Rpc from "@/Rpc";
import RpcClass from "@/server/RpcClass";
import Activity from "@/activity/Activity";
import ActivityManager from "@/activity/ActivityManager";
import Product from "@/server/com/silkplm/model/plm/Product";

const DataImport = () => require("@/components/forms/DataImport");

export const CAN_DELETE = "CAN_DELETE";
export const SUGGEST_REPLACEMENT = "SUGGEST_REPLACEMENT";
export const FORCE_REPLACEMENT = "FORCE_REPLACEMENT";
export const DELETE_RESTRICTED = "DELETE_RESTRICTED";
export const DELETE_NOT_PERMITTED = "DELETE_NOT_PERMITTED";

export const MULTISELECT_ID_ONLY = "ID_ONLY";
export const MULTISELECT_ID_AND_PERMS = "ID_AND_PERMS";
export const MULTISELECT_ID_FULL_ROW = "FULL_ROW";

class _FormsActions {
    constructor() {
    }

    setContext(props, onlyIds) {
        if (!props.context) {
            props.context = {};
        }
        props.context.list = props.list ?? null;
        props.context.multiSelect = props.multiSelect ?? false;
        props.context.multiSelectAutoOn = props.multiSelectAutoOn ?? false;
        props.context.showAdd = props.showAdd ?? true;
        props.context.showDelete = props.showDelete ?? true;
        props.context.showImport = props.showImport ?? true;
        props.context.showExport = props.showExport ?? true;
        props.context.formTitle = props.formTitle ?? "";
        props.context.onlyIds = onlyIds;
    }

    /**
     * @param {BusinessEntity|String} entityIdOrEntity
     * @return String
     * @private
     */
    _decodeId(entityIdOrEntity) {
        let id = null;
        if (_.isString(entityIdOrEntity)) {
            id = entityIdOrEntity;
        } else if (entityIdOrEntity.hasOwnProperty("id")) {
            id = entityIdOrEntity['id'];
        } else {
            throw new Error("Unknown object, cat find id:" + JSON.stringify(entityIdOrEntity));
        }

        return id;
    }

    /**
     * @param {FormConfig|String|Type|number} typeOrTypenameOrFormConfigOrFormId
     * @param {Object} props
     * @param onlyIds
     * @return {Promise<null|Activity>}
     */
    async showList(typeOrTypenameOrFormConfigOrFormId, props, onlyIds) {
        props = props || {}
        this.setContext(props, onlyIds);
        return FormsLoader.showList(typeOrTypenameOrFormConfigOrFormId, props);
    }


    /**
     * @param {FormConfig|String|Type|number} typeOrTypenameOrFormConfigOrFormId
     * @param {Object} props
     * @param excludedIds
     * @param activityType
     * @return {Promise<null|Activity>}
     */
    async showMultiSelectList(typeOrTypenameOrFormConfigOrFormId, props = {}, excludedIds = [], activityType = "select") {
        props = {...props, multiSelect: true, multiSelectAutoOn: true};
        return this.showSelectList(typeOrTypenameOrFormConfigOrFormId, props, excludedIds, activityType);
    }

    /**
     * @param {FormConfig|String|Type|number} typeOrTypenameOrFormConfigOrFormId
     * @param {Object} props
     * @param onlyIds
     * @param activityType
     * @return {Promise<null|Activity>}
     */
    async showMultiSelectListFromIds(typeOrTypenameOrFormConfigOrFormId, props = {}, onlyIds = [], activityType = "select") {
        props = {...props, multiSelect: true, multiSelectAutoOn: true};
        return this.showSelectList(typeOrTypenameOrFormConfigOrFormId, {...props, onlyIds}, [], activityType);
    }

    /**
     * @param {FormConfig|String|Type|number} typeOrTypenameOrFormConfigOrFormId
     * @param {Object} props
     * @param excludedIds
     * @param activityType
     * @return {Promise<null|Activity>}
     */
    async showSelectList(typeOrTypenameOrFormConfigOrFormId, props = {}, excludedIds = [], activityType = "select") {
        this.setContext(props);
        let res = FormsLoader.showSelectList(typeOrTypenameOrFormConfigOrFormId, props, excludedIds, activityType);
        res.then(activity => {
            if (activity) {
                if (activity.getActivityType() === Activity.DEFAULT) {
                    activity.setActivityType(activityType);
                }
            }
        });
        return res;
    }

    // /**
    //  * @param {FormConfig|String|Type|number} typeOrTypenameOrFormConfigOrFormId
    //  * @param {Object} props
    //  * @param onlyIds
    //  * @param activityType
    //  * @return {Promise<null|Activity>}
    //  */
    // async showSelectListFromIds(typeOrTypenameOrFormConfigOrFormId, props = {}, onlyIds = [], activityType = "select") {
    //     this.setContext(props);
    //     let res = FormsLoader.showSelectList(typeOrTypenameOrFormConfigOrFormId, {...props, onlyIds}, [], activityType);
    //     res.then(activity => {
    //         if (activity) {
    //             if (activity.getActivityType() === Activity.DEFAULT) {
    //                 activity.setActivityType(activityType);
    //             }
    //         }
    //     });
    //     return res;
    // }


    /**
     * @param {FormConfig|string|Type|number} typeOrTypenameOrFormConfigOrFormId
     * @param formValidatedFieldWithParent
     * @param {Object} props
     * @param excludedIds
     * @param activityType
     * @return {Promise<null|Activity>}
     */
    async showSelectListWithParentId(typeOrTypenameOrFormConfigOrFormId,
                                     formValidatedFieldWithParent,
                                     props = {},
                                     excludedIds = [],
                                     activityType = "select") {
        if (!props.context) {
            props.context = {};
        }
        props.context.multiSelect = props.multiSelect ?? false;
        props.context.multiSelectAutoOn = props.multiSelectAutoOn ?? false;
        props.context.allowNullSelection = props.allowNullSelection ?? true;
        let res = FormsLoader.showSelectListWithParentId(typeOrTypenameOrFormConfigOrFormId, formValidatedFieldWithParent, props, excludedIds, activityType);
        res.then(activity => {
            if (activity.getActivityType() === Activity.DEFAULT) {
                activity.setActivityType(activityType);
            }
        });

        return res;
    }

    /**
     * @method
     * @param {BaseFormConfig} typeOrTypenameOrFormConfigOrFormId
     * @param {BusinessEntity|String} entityIdOrEntity
     * @param {Object?} props
     * @return {Promise<null|Activity>}
     *
     */
    async editEntity(typeOrTypenameOrFormConfigOrFormId, entityIdOrEntity, props = {}) {
        let id = this._decodeId(entityIdOrEntity);
        return FormsLoader.showForm(typeOrTypenameOrFormConfigOrFormId,
            {...props, mode: 'EDIT', entityId: id});
    }

    /**
     * @method
     * @param {FormConfig|String|Type|number} typeOrTypenameOrFormConfigOrFormId
     * @param {BusinessEntity} tmpInstance
     * @param {Object?} props
     * @return {Promise<null|Activity>}
     *
     */
    async editTmpEntity(typeOrTypenameOrFormConfigOrFormId, tmpInstance, props = {}) {

        return FormsLoader.showForm(typeOrTypenameOrFormConfigOrFormId,
            {...props, mode: 'EDIT', temporaryInstanceToEdit: tmpInstance});
    }


    /**
     ** @param {DataEntity} entity
     * @param {*?} props
     * @return {Promise<null|Activity>}
     */
    async edit(entity, props = {}) {
        const type = this.getTypeOf(entity);
        return this.editEntity(type, this._decodeId(entity), props);
    }

    getTypeOf(entity) {
        return Object.getPrototypeOf(entity)?.__metadata__?.__type__ ?? entity?.__metadata__?.__type__;
    }

    /**
     ** @param {DataEntity} entity
     * @param {*?} props
     * @return {Promise<null|Activity>}
     */
    async editDetail(entity, detailsConfig, masterId, props = {}) {
        if (masterId == null || detailsConfig == null) {
            return this.edit(entity, props);
        }
        // TODO ALLOW MOVE
        // if allowMove to nie wypełniać tych propsów, tylko zwrócić entity type, id
        let masterFormConfig = FormsLoader.detectFormConfig(entity, false, true);
        const type = this.getTypeOf(entity);
        let props2 = {...props, detailsConfig, masterFormConfig, masterId}
        return this.editEntity(type, this._decodeId(entity), props2);
    }

    async editView(formConfig, entity, props = {}) {
        let classToOpen = formConfig.openViewAsClazz;
        let formConfigToOpen = FormsLoader.detectFormConfig(classToOpen);
        let idToOpen = null;
        for (let member of Object.values(formConfig.members)) {
            if (member.clazz === classToOpen) {
                let fieldName = member.shortId;
                idToOpen = entity[fieldName];
            }
        }
        return FormsLoader.showForm(formConfigToOpen,
            {...props, mode: 'EDIT', entityId: idToOpen});
    }

    /**
     * @param {FormConfig|String|Type|number} typeOrTypenameOrFormConfigOrFormId
     * @param {FormDetailsConfig} detailsConfig
     * @param {String|null?} masterId
     * @param {Object?} props
     * @return {Promise<null|Activity>}
     */
    async createDetail(typeOrTypenameOrFormConfigOrFormId, detailsConfig, masterId, props = {}) {
        let masterFormConfig = FormsLoader.detectFormConfig(typeOrTypenameOrFormConfigOrFormId);
        let detailFormConfig = FormsLoader.detectFormConfig(detailsConfig.detailsClass);

        return FormsLoader.showForm(detailFormConfig,
            {...props, mode: 'NEW', detailsConfig, masterFormConfig, masterId});
    }


    /**
     * @param {FormConfig|String|Type|number} typeOrTypenameOrFormConfigOrFormId
     * @param {FormDetailsConfig} detailsConfig
     * @param {TemporaryList|null?} temporaryListToAdd
     * @param masterId
     * @param {Object?} props
     * @return {Promise<null|Activity>}
     */
    async createDetailEntity(typeOrTypenameOrFormConfigOrFormId, detailsConfig, temporaryListToAdd, masterId, props = {}) {
        if (temporaryListToAdd) {
            return await FormsActions.createTmpDetail(typeOrTypenameOrFormConfigOrFormId, detailsConfig, temporaryListToAdd, props);
        } else {
            return await FormsActions.createDetail(typeOrTypenameOrFormConfigOrFormId, detailsConfig, masterId, props);
        }
    }

    /**
     * @param {FormConfig|String|Type|number} typeOrTypenameOrFormConfigOrFormId
     * @param {FormDetailsConfig} detailsConfig
     * @param {TemporaryList|null?} temporaryListToAdd
     * @param {Object?} props
     * @return {Promise<null|Activity>}
     */
    async createTmpDetail(typeOrTypenameOrFormConfigOrFormId, detailsConfig, temporaryListToAdd, props = {}) {
        let masterFormConfig = FormsLoader.detectFormConfig(typeOrTypenameOrFormConfigOrFormId);
        let detailFormConfig = FormsLoader.detectFormConfig(detailsConfig.detailsClass);

        return FormsLoader.showForm(detailFormConfig,
            {...props, mode: 'NEW', detailsConfig, masterFormConfig, temporaryListToAdd});
    }


    /**
     * @param {FormConfig|String|Type|number} typeOrTypenameOrFormConfigOrFormId
     * @param {Object} props
     * @return {Promise<null|Activity>}
     */
    async create(typeOrTypenameOrFormConfigOrFormId, props = {}) {
        return FormsLoader.showForm(typeOrTypenameOrFormConfigOrFormId,
            {mode: 'NEW', ...props});
    }

    async importData(typeOrTypenameOrFormConfigOrFormId, props = {}) {
        // TODO
        return await ActivityManager.showActivity(DataImport);
    }

    async delete(entity, showConfirmation = true) {
        const type = Object.getPrototypeOf(entity)?.__metadata__?.__type__ ?? entity?.__metadata__?.__type__;
        return this.deleteEntity(type, entity, showConfirmation);
    }

    async deleteList(listEntity, showConfirmation = true, temporaryList) {
        const type = Object.getPrototypeOf(listEntity[0])?.__metadata__?.__type__ ?? listEntity[0]?.__metadata__?.__type__;
        return await this.deleteEntityList(type, listEntity, showConfirmation, temporaryList);
    }

    async replacementFunction(formConfig, id, entityLabel) {
        // add replacementshowSelectList
        let result = await (await this.showSelectList(formConfig, {}, [id], Activity.SELECT_REPLACEMENT)).getResult();
        if (result) {
            let replacementLabel = FormsAI.getEntityLabel(formConfig, result);
            if (!await DialogManager.yesNo($tr("formsActions.deleting.title", "Deleting #{1}", formConfig.entityName),
                $tr("formsActions.sure.delete.massage", "Are you sure you want to delete #{1} and replace it by #{2}? ",
                    entityLabel, replacementLabel), false)) {
                return false;
            }

            await Rpc.Forms.deleteEntityWithReplacement(formConfig.formClassLong, id, result.id);
            return true;
        }
        return false;
    }


    async forceReplacementOperation(formConfig, id, entityLabel) {
        if ("replace" === await DialogManager.replaceOrDelete($tr("replacementRequired", "Replacement required"),
            $tr("formsActions.records.related", "There are other records related to #{1} - you have to choose the other #{2} - " +
                "that is going to replace #{3} Do you like to continue?", entityLabel, formConfig.entityName, entityLabel), false)) {

            return await this.replacementFunction(formConfig, id, entityLabel);

        } else {
            return false;
        }
        return false;
    }

    async suggestReplacementOperation(formConfig, id, entityLabel) {
        let res = await DialogManager.replaceOrDelete($tr("replacement", "Replacement"),
            $tr("formsActions.record.related.may.choose",
                "There are other records related to #{1}  - optionally, you may choose the other #{2}" +
                " to replace #{3} Do you like to continue?", entityLabel, formConfig.entityName, entityLabel), true);
        if ("replace" === res) {
            return await this.replacementFunction(formConfig, id, entityLabel);
        } else if ("cancel" === res) {
            return false;
        } else {
            //"delete"
            formConfig.isDynamic ?
                await Rpc.Forms.deleteDynamicEntity(formConfig.formClassLong, id) :
                await Rpc.Forms.deleteEntity(formConfig.formClassLong, id);
            return true;
        }
    }

    /**
     * @param {FormConfig|String|Type|number} typeOrTypenameOrFormConfigOrFormId
     * @param {BusinessEntity|String} entityIdOrEntity
     * @param {boolean?}  showConfirmation
     * @return {Promise<boolean>}
     */
    async deleteEntity(typeOrTypenameOrFormConfigOrFormId, entityIdOrEntity, showConfirmation = true) {
        let id = this._decodeId(entityIdOrEntity);
        const formConfig = FormsLoader.detectFormConfig(typeOrTypenameOrFormConfigOrFormId, false, true);
        let entityLabel;

        if (entityIdOrEntity instanceof RpcClass) {
            entityLabel = FormsAI.getEntityLabel(formConfig, entityIdOrEntity);
        } else {
            entityLabel = FormsAI.getEntityLabel(formConfig, null);
        }

        let beforeDeleteDialogExtraMessage = null;
        if (formConfig.beforeDeleteDialogInfo) {
            beforeDeleteDialogExtraMessage = formConfig.isDynamic ?
                await Rpc.Forms.beforeDeleteDynamicEntityDialog(formConfig.formClassLong, id) :
                await Rpc.Forms.beforeDeleteEntityDialog(formConfig.formClassLong, id);
        }
        let canDeleteWithInfo = formConfig.isDynamic ?
            await Rpc.Forms.canDeleteDynamicEntity(formConfig.formClassLong, id) :
            await Rpc.Forms.canDeleteEntity(formConfig.formClassLong, id);

        let productFormClassLong = await Product.getRemoteClass();
        if (formConfig.formClassLong === productFormClassLong) {
            let quantityOfProductInSeasonForProduct = await Rpc.plm.services.ProductService.calculateProductInSeasonForProduct(id);
            let quantityOfOrderDetailsForProduct = await Rpc.plm.services.ProductService.calculateOrderDetailsForProduct(id);
            if (quantityOfProductInSeasonForProduct > 0 && quantityOfOrderDetailsForProduct === 0) {
                if (await DialogManager.yesNo($tr("formsActions.deletingProduct", "Deleting Product"),
                    $tr("formsActions.sure.delete.product.message", "Are you sure you want to delete Product with assigned Product in Season?"))) {
                    await Rpc.Forms.deleteEntity(formConfig.formClassLong, id);
                    return true;
                } else {
                    return false;
                }
            }
        }

        if (canDeleteWithInfo.canDelete === DELETE_RESTRICTED) {
            let message = canDeleteWithInfo.extraInfoFromCanDelete ? canDeleteWithInfo.extraInfoFromCanDelete :
                $tr("formsActions.record.related.cent.delete",
                    "There are other records related to #{1}, you can't delete the record.", entityLabel)
            DialogManager.info($tr("deleteRestricted", "Delete restricted"), message).then();
            return false;
        }
        if (canDeleteWithInfo.canDelete === DELETE_NOT_PERMITTED) {
            let message = canDeleteWithInfo.extraInfoFromCanDelete ? canDeleteWithInfo.extraInfoFromCanDelete :
                $tr("formsActions.record.related.delete.tree", "There are other records related to #{1} - you don't have sufficient permissions to delete the entire tree.", entityLabel)
            DialogManager.info($tr("deleteForbidden", "Delete forbidden"), message).then();
            return false;
        }

        if (canDeleteWithInfo.canDelete === FORCE_REPLACEMENT) {
            return await this.forceReplacementOperation(formConfig, id, entityLabel);
        }
        if (canDeleteWithInfo.canDelete === SUGGEST_REPLACEMENT) {
            return await this.suggestReplacementOperation(formConfig, id, entityLabel);
        }
        if (showConfirmation) {
            let title = $tr("formsActions.deleting.formConfig.entityName", "Deleting #{1}", formConfig.entityName);
            let message = $tr("formsActions.sure.delete.entityLabel", "Are you sure you want to delete #{1}? ", entityLabel) +
                (beforeDeleteDialogExtraMessage ? "</br><b>" + beforeDeleteDialogExtraMessage + "</b>" : '');
            if (await DialogManager.yesNo(title, message, false)) {
                formConfig.isDynamic ?
                    await Rpc.Forms.deleteDynamicEntity(formConfig.formClassLong, id) :
                    await Rpc.Forms.deleteEntity(formConfig.formClassLong, id);
                return true;
            } else {
                return false;
            }
        } else {
            formConfig.isDynamic ?
                await Rpc.Forms.deleteDynamicEntity(formConfig.formClassLong, id) :
                await Rpc.Forms.deleteEntity(formConfig.formClassLong, id);
            return true;
        }
    }

    /**
     * @param {FormConfig|String|Type|number} typeOrTypenameOrFormConfigOrFormId
     * @param {List<BusinessEntity>} listEntityIdOrEntity
     * @param {boolean?}  showConfirmation
     * @param {List<BusinessEntity>?}  temporaryList
     * @return {Promise<boolean>}
     */
    async deleteEntityList(typeOrTypenameOrFormConfigOrFormId, listEntityIdOrEntity, showConfirmation = true, temporaryList) {
        let listOfEntitiesId = [];
        const formConfig = FormsLoader.detectFormConfig(typeOrTypenameOrFormConfigOrFormId);

        for (let entityIdOrEntity of listEntityIdOrEntity) {
            let id = this._decodeId(entityIdOrEntity);
            listOfEntitiesId.push(id);
        }
        let beforeDeleteDialogExtraMessage = null;
        if (formConfig.beforeDeleteDialogInfo) {
            beforeDeleteDialogExtraMessage = formConfig.isDynamic ?
                await Rpc.Forms.beforeDeleteDynamicEntityDialogBulkDelete(formConfig.formClassLong, listOfEntitiesId) :
                await Rpc.Forms.beforeDeleteEntityDialogBulkDelete(formConfig.formClassLong, listOfEntitiesId);
        }
        for (let id of listOfEntitiesId) {
            let canDeleteWithInfo = formConfig.isDynamic ?
                await Rpc.Forms.canDeleteDynamicEntity(formConfig.formClassLong, id) :
                await Rpc.Forms.canDeleteEntity(formConfig.formClassLong, id);

            let entityLabel;
            if (id instanceof RpcClass) {
                entityLabel = FormsAI.getEntityLabel(formConfig, id);
            } else {
                entityLabel = FormsAI.getEntityLabel(formConfig, null);
            }

            if (canDeleteWithInfo.canDelete === DELETE_RESTRICTED) {
                let message = canDeleteWithInfo.extraInfoFromCanDelete ? canDeleteWithInfo.extraInfoFromCanDelete :
                    $tr("formsActions.cant.delete.entityLabel", "There are other records related to #{1} you can't delete this records.", entityLabel)
                DialogManager.info($tr("formsActions.deleteRestricted", "Delete restricted"), message).then();
                return false;
            }
            if (canDeleteWithInfo.canDelete === DELETE_NOT_PERMITTED) {
                let message = canDeleteWithInfo.extraInfoFromCanDelete ? canDeleteWithInfo.extraInfoFromCanDelete :
                    $tr("formsActions.dont.sufficient.permissions",
                        "There are other records related to #{1} - you don't have sufficient permissions to delete the entire tree.", entityLabel)
                DialogManager.info($tr("deleteForbidden", "Delete forbidden"), message).then();
                return false;
            }
            if (canDeleteWithInfo.canDelete === FORCE_REPLACEMENT) {
                return await this.forceReplacementOperation(formConfig, id, entityLabel);
            }
            if (canDeleteWithInfo.canDelete === SUGGEST_REPLACEMENT) {
                return await this.suggestReplacementOperation(formConfig, id, entityLabel);
            }
        }

        if (showConfirmation) {
            let title = $tr("formsActions.deleting.formConfig.entityPlural", "Deleting #{1}", formConfig.entityPlural);
            let message = $tr("formsActions.sure.delete.formConfig.entityPlural.pt.1",
                    "Are you sure you want to delete selected ") + "<b>" + listOfEntitiesId.length + "</b>" + $tr("formsActions.sure.delete.formConfig.entityPlural.pt.2", " elements from  #{1}?", formConfig.entityPlural) +
                (beforeDeleteDialogExtraMessage ? "</br><b>" + beforeDeleteDialogExtraMessage + "</b>" : '')
            if (await DialogManager.yesNo(title, message, false)) {
                if (temporaryList) {
                    return true;
                }
                formConfig.isDynamic ?
                    await Rpc.Forms.deleteDynamicEntities(formConfig.formClassLong, listOfEntitiesId) :
                    await Rpc.Forms.deleteEntities(formConfig.formClassLong, listOfEntitiesId);
                return true;
            } else {
                return false;
            }
        } else {
            formConfig.isDynamic ?
                await Rpc.Forms.deleteDynamicEntities(formConfig.formClassLong, listOfEntitiesId) :
                await Rpc.Forms.deleteEntities(formConfig.formClassLong, listOfEntitiesId);
            return true;
        }

    }

    /**
     * @param {ComputedLink} link
     */
    async goTo(link) {
        if (link.type === "entity") {
            let translatedLink = await Rpc.Forms.getParentLink(link);
            return this.editEntity(translatedLink.clazz, translatedLink.id);
        }
    }
}


const FormsActions = new _FormsActions();
export default FormsActions;